export var BUGSNAG_FE_API_KEY = process.env.BUGSNAG_FE_API_KEY || "";
